// extracted by mini-css-extract-plugin
export default {"section":"Waling_section__tVAFY","spaceBetween":"Waling_spaceBetween__1Aj27","rightAlign":"Waling_rightAlign__TfUXL","banWrapper":"Waling_banWrapper__JdVFH"};